import { CookieOutlineIcon } from './CookieOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AF77B3DF-8565-4A84-A58F-83FD2E55EB10
 * name cookie-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-outline.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitOutlineIcon = CookieOutlineIcon;
export default BiscuitOutlineIcon